export const ALERT_CREATED = "ALERT_CREATED";
export const ALERT_AUTO_REMOVE = "ALERT_AUTO_REMOVE";
export const ALERT_DELETED = "ALERT_DELETED";
